"use client";

import posthog from "posthog-js";
import { PostHogProvider as PostHogProviderWrap } from "posthog-js/react";
import { type ReactNode, Suspense, useEffect } from "react";
import { env } from "@/env";
import PostHogPageView from "./PostHogPageView";

export function PostHogProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    if (env.NEXT_PUBLIC_POSTHOG_KEY) {
      console.debug("Initializing PostHog...");

      posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY, {
        api_host: env.NEXT_PUBLIC_POSTHOG_HOST,
        ui_host: "https://us.posthog.com",
        person_profiles: "identified_only", // or 'always' to create profiles for anonymous users as well
        capture_pageview: false, // Disable automatic pageview capture, as we capture manually
        capture_pageleave: true, // Enable pageleave capture
        defaults: "2026-01-30",
      });
    }
  }, []);

  return (
    <PostHogProviderWrap client={posthog}>
      <Suspense>
        <PostHogPageView />
      </Suspense>

      {children}
    </PostHogProviderWrap>
  );
}
